<template>
    <div class="card">
      <div class="card-header text-lg cardAguardandoLiberacao">
        <span class="badge badge-warning mr-2">{{ iniciadas.length }}</span>
        {{ $t('Aguardando Liberacao') }}
      </div>
  
      <div class="card-body">
        <div class="row align-items-center">
          <div class="col-12 text-center pt-3 animated fadeout" v-if="!iniciadas">
            <span style="font-size: 2rem">
              <i class="fas fa-pulse fa-spinner mr-3"></i>Carregando...
            </span>
          </div>
          <div class="col-12 text-center pt-3 animated fadeout" v-if="iniciadas && iniciadas.length == 0">
            <span style="font-size: 2rem">
              {{ $t('Nenhuma OS aguardando liberacao') }}.
            </span>
          </div>

          <div class="col-12" v-if="iniciadas">
            <div v-for="(tecnico, index) in iniciadas" :key="index">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body bg-light">
                      <execucao-pendente :execucao="tecnico"></execucao-pendente>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <modal-tecnicos></modal-tecnicos>
    </div>
  </template>
  
  <script>
  // import ExecucaoAtiva from '@/components/ExecucaoAtiva'
  import ExecucaoPendente from '@/components/ExecucaoPendente'
  import ModalTecnicos from '@/components/ModalTecnicos'
  
  export default {
    components: {
      // ExecucaoAtiva,
      ExecucaoPendente,
      ModalTecnicos
    },
  
    data() {
      return {
        visible: null,
        nameMecanico: '',
        numExecucao: 0
      }
    },

    created(){
      const data = {
        nr_tipo: 'L'
      }
      this.$store.dispatch('osItemExecucao/fetchOsLiberacao', { data: data })
    },

    computed: {
      filial() {
        return this.$store.getters['filial/filial']
      },
      frotaItems() {
        const items = this.$store.getters['frotaItem/items']
  
        if (!items && this.filial) {
          this.$store.dispatch('frotaItem/fetchFromApi', {
            params: {
              filial: this.filial.nr_sequencial, estoque: true
            }
          })
          return []
        }
        return items
      },
  
      iniciadas() {
        if(this.$store.getters['osItemExecucao/osLiberacao']){
  
          this.totExecucao(this.$store.getters['osItemExecucao/osLiberacao'])
        }
        return this.$store.getters['osItemExecucao/osLiberacao']
      },
      countExecucao() {
        return this.$store.getters['osItemExecucao/osLiberacao']
      },
    },
  
    methods: {
      mostraParar(tecnico) {
        let mecanicoOs = JSON.parse(localStorage.filial)
        if (mecanicoOs.atendeOs === 'S') {
          if (tecnico == mecanicoOs.dsColaborador) {
  
            return true
          }
  
          return false
        }
  
        return true
      },
      totExecucao(response) {
        let mecanicoOs = JSON.parse(localStorage.filial)
        if (mecanicoOs.atendeOs == 'S') {
          for (let i = 0; i <= response.length; i++) {
            if (response[i] != undefined) {
              if (mecanicoOs.dsColaborador == response[i].ds_colaborador) {
                this.numExecucao = response[i].execucoes_iniciadas.length
              }
            }
          }
        } else {
          this.numExecucao = this.countExecucao
        }
      }
    }
  }
  </script>
<style>
.cardAguardandoLiberacao{
  background:linear-gradient(45deg, #02961a, #05c024) ;
  border-radius: 25px!important;
  color: #fff;
}
</style>
  